import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { MatIcon } from '../components/mat-icon/mat-icon';
import { RouterLink } from "@angular/router";

@Component({
  selector: 'app-page-not-found',
  imports: [TranslatePipe, ButtonModule, MatIcon, RouterLink],
  templateUrl: './page-not-found.html',
  styleUrl: './page-not-found.scss',
})
export class PageNotFound {}
